/* RESPONSIBLE TEAM: team-actions */
import { buildValidations, validator } from 'ember-cp-validations';
import ENV from 'embercom/config/environment';

export default buildValidations({
  url: [
    validator('presence', true, {
      messageKey: 'workflow-connector.builder.body.request.url.https',
    }),
    validator('format', {
      type: 'url',
      disabled: ENV.environment === 'development',
    }),
    validator('https-except-in-development'),
  ],
  clientId: {
    validators: [
      validator('presence', {
        presence: true,
        messageKey: 'settings.custom-authentication-tokens.new.blank-field',
      }),
    ],
  },
  clientSecret: {
    validators: [
      validator('presence', {
        presence: true,
        messageKey: 'settings.custom-authentication-tokens.new.blank-field',
      }),
    ],
  },
});
